// Install progress (#106). Ordered list must match the phase emitter in
// edge/modem-gateway/scripts/updater_service.py. Step indices are 1-based
// and rendered as "Step X/N".
export interface InstallPhase {
  key: string;
  label: string;
}

export const INSTALL_PHASES: ReadonlyArray<InstallPhase> = [
  { key: 'python_downloading',  label: 'Downloading Python runtime' },
  { key: 'python_extracting',   label: 'Installing Python runtime' },
  { key: 'release_downloading', label: 'Downloading release' },
  { key: 'release_extracting',  label: 'Installing release' },
  { key: 'service_starting',    label: 'Starting service' },
  { key: 'health_waiting',      label: 'Waiting for service health' },
  { key: 'awaiting_reboot',     label: 'Awaiting reboot (confirm in SSH terminal)' },
];

export function getPhaseIndex(phase: string): number {
  return INSTALL_PHASES.findIndex(p => p.key === phase);
}

export function formatElapsed(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  const r = s % 60;
  return r ? `${m}m ${r}s` : `${m}m`;
}
